import { type FunctionComponent } from 'react';
import { FilterByRooms } from './filter-by-rooms/filter-by-rooms.component';
import { FilterByStyles } from './filter-by-styles/filter-by-styles.component';

export type FilterLooksProps = {
	updateSelection: (groupName: 'room' | 'style', value: string) => void;
	selectedRooms: string[];
	selectedStyles: string[];
	isAllFavorites?: boolean;
};

export const FilterLooks: FunctionComponent<FilterLooksProps> = ({
	updateSelection,
	selectedRooms,
	selectedStyles,
	isAllFavorites = false
}) => {
	const handleRoomsFilterSelection = (room: string) => {
		if (selectedRooms.includes(room) && selectedRooms.length === 1) {
			selectedStyles.forEach((style) => updateSelection('style', style));
		}
		updateSelection('room', room);
	};

	const handleStylesFilterSelection = (style: string) => {
		updateSelection('style', style);
	};

	return (
		<div data-testid="looks-by-room">
			<FilterByRooms onSelectedRoom={handleRoomsFilterSelection} selectedRooms={selectedRooms} isAllFavorites={isAllFavorites} />
			{((selectedRooms && selectedRooms.length > 0) || (selectedStyles && selectedStyles.length > 0)) && (
				<FilterByStyles
					onSelectedStyle={handleStylesFilterSelection}
					selectedStyles={selectedStyles}
					isAllFavorites={isAllFavorites}
				/>
			)}
		</div>
	);
};
